import { ApprovalReportLayout } from './ApprovalReportLayout';

export function ApprovalReportPage() {
  return <ApprovalReportLayout title="Market Promotion Approval Report" routeId="approvalReport" />;
}
